'use client';

import { SAVED_COPY_MARK } from 'BomdisoftComponents/pwa/register-service-worker/render';
import { SavedCopyOffer } from 'BomdisoftComponents/pwa/register-service-worker/saved-copy-offer';
import { useEffect, useState } from 'react';

export { SAVED_COPY_MARK } from 'BomdisoftComponents/pwa/register-service-worker/render';

export type RegisterServiceWorkerProps = {
  swUrl?: string;
};

// WHY a client component with useEffect (not next/script): registration has no pre-paint
// requirement and must run client-side only, after hydration —
// a plain effect is the simplest correct primitive. Registration failures are left unhandled
// (not swallowed) so the app's global Sentry unhandled-rejection handler captures them.
export const RegisterServiceWorker = ({ swUrl = '/sw.js' }: RegisterServiceWorkerProps) => {
  const [isOffering, setIsOffering] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

    navigator.serviceWorker.register(swUrl);
  }, [swUrl]);

  useEffect(() => {
    if (document.querySelector(`meta[name="${SAVED_COPY_MARK}"]`) === null) return;

    const handleOnline = () => setIsOffering(true);
    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);

  return isOffering ? <SavedCopyOffer onClose={() => setIsOffering(false)} /> : null;
};
